import React from "react";
import { Column } from "./Column";

export const ColumnHalf = props => (
  <Column width={1 / 2} padding={props.paddingValue !== undefined ? props.paddingValue : 3}>
    {props.children}
  </Column>
);
